import * as React from "react";

export default function PhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 507.172 507.172">
      <g>
        <g>
          <path
            d="M253.588,0C113.764,0,0,113.76,0,253.592c0,139.828,113.764,253.58,253.588,253.58s253.584-113.752,253.584-253.58
     C507.168,113.76,393.412,0,253.588,0z M387.108,349.432l-24.032,24.036c-1.548,1.548-4.056,1.548-5.604,0L352.5,368.5
     c-10.28,6.42-24.424,15.288-26.432,16.624c-2.372,2.256-5.62,3.564-8.948,3.564c-2.464,0-4.872-0.696-6.96-2.024
     c-69.444-44.032-145.676-120.276-189.72-189.72c-3.164-5-2.504-11.612,1.524-15.884c1.356-2.08,10.052-16.384,16.34-26.756
     l-5.008-5.008c-0.744-0.748-1.16-1.752-1.16-2.804c0-1.048,0.416-2.056,1.16-2.8l24.032-24.036c1.476-1.484,4.108-1.484,5.6,0
     l67.132,67.124c0.748,0.744,1.164,1.752,1.164,2.796c0,1.056-0.416,2.064-1.164,2.804l-24.032,24.032
     c-1.548,1.544-4.056,1.544-5.608,0l-4.852-4.852l-11.672,11.672c24.924,31.28,68.264,74.66,99.604,99.688l11.712-11.72
     l-4.86-4.852c-0.748-0.744-1.164-1.752-1.164-2.804c0-1.04,0.416-2.056,1.164-2.796l24.032-24.048c1.488-1.484,4.12-1.484,5.604,0
     l67.116,67.124C388.656,345.376,388.656,347.884,387.108,349.432z"
          />
        </g>
      </g>
    </svg>
  );
}
